/** Two rows of one line may share neither an outcome nor a landing location. */
export const RETURN_DUPLICATE_ROW_MESSAGE = 'This line already has a row with that outcome and location.';
//# sourceMappingURL=return-duplicate-row-message.js.map